import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import { ReactComponent as AppLogo } from '../../../assets/appLogo.svg';
import { ReactComponent as ARLogo } from '../../../assets/ARMedicid_logo.svg';
import * as Constant from '../../../constants/actionTypes';
import actions from '../../../actions';
import '../../webCommonStyles.css';
import { labelName } from '../../UtilsWeb';
import styleConfig from '../../muiTheme';
import styles from './styles';

class Header extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  handleToggle = () => {
    const { isOpen } = this.state;
    this.setState(() => ({ isOpen: !isOpen }));
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }
    this.setState({ isOpen: false });
  };

  selectLanguage = selectedLang => {
    const { changeLocale } = this.props;
    changeLocale(selectedLang);
    sessionStorage.setItem('locale', selectedLang);
    this.handleToggle();
  };

  render() {
    const { appTitle, classes, supportedLanguages } = this.props;
    const { isOpen } = this.state;

    return (
      <header className={classes.headerBackground}>
        <div className="loginHeader">
          <div className="languageWrapper">
            <Button
              buttonRef={node => {
                this.anchorEl = node;
              }}
              aria-owns={isOpen ? 'menu-list-grow' : undefined}
              aria-haspopup="true"
              onClick={this.handleToggle}
              style={{
                color: styleConfig.palette.paleYellow,
                textTransform: 'capitalize',
                fontSize: 12,
              }}
            >
              {labelName(Constant.LABEL_LANGUAGE)}
            </Button>
            <Popper open={isOpen} anchorEl={this.anchorEl} transition disablePortal>
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  id="menu-list-grow"
                  style={{
                    transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={this.handleClose}>
                      <div className={classes.langButtonWrapper}>
                        {supportedLanguages?.data?.map(item => (
                          <div
                            key={item.LanguageCode.toLowerCase()}
                            role="button"
                            tabIndex={0}
                            onClick={() => this.selectLanguage(item.LanguageCode.toLowerCase())}
                            onKeyDown={e => {
                              if (e.key === 'Space' || e.key === 'Enter') {
                                this.selectLanguage(item.LanguageCode.toLowerCase());
                              }
                            }}
                            className={classes.langButton}
                          >
                            {item.Language}
                          </div>
                        ))}
                      </div>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>
          <div className="logoAppName">
            <div className="appName">
              <AppLogo alt="MDP Logo" style={{ width: 60, height: 60, marginRight: 7 }} />
              <h1 className="appHeader">{appTitle}</h1>
            </div>
            <div className="vendorName">
              <ARLogo className={classes.logoStyle} alt="Gainwell logo" />
            </div>
          </div>
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  appTitle: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  changeLocale: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  supportedLanguages: PropTypes.object.isRequired,
};

const mapStateToProp = state => {
  const { locale } = state.locale;
  const { supportedLanguages } = state;
  return {
    locale,
    supportedLanguages,
  };
};

const mapDispatchToProps = dispatch => ({
  changeLocale: locale => {
    dispatch(actions.changeLocale(locale));
  },
});

export default connect(mapStateToProp, mapDispatchToProps)(withStyles(styles)(Header));
